import { Link } from "react-router-dom";

import { publicAsset } from "./publicAsset";
import { organizerSectionHref, SiteLink, siteHomePath, type SitePage } from "./SiteHeader";
import "./SiteFooter.css";

interface FooterLink {
  label: string;
  to: string;
}

interface FooterColumn {
  id: string;
  title: string;
  links: FooterLink[];
}

function footerColumns(page: SitePage): FooterColumn[] {
  return [
    {
      id: "t123-footer-sitio",
      title: "Torneos123",
      links: [
        { label: "Torneos abiertos", to: "/torneos" },
        { label: "Para organizadores", to: "/organizador" },
        { label: "Para jugadores", to: "/jugador" },
        { label: "Precio", to: organizerSectionHref(page, "precio") },
      ],
    },
    {
      id: "t123-footer-ayuda",
      title: "Ayuda",
      links: [
        { label: "Guía del organizador", to: "/guia" },
        { label: "Pedir demo", to: organizerSectionHref(page, "demo") },
        { label: "Iniciar sesión", to: "/login" },
      ],
    },
    {
      // «Términos y condiciones» se agrega aquí cuando exista esa página.
      id: "t123-footer-legal",
      title: "Legal",
      links: [{ label: "Aviso de privacidad", to: "/aviso-de-privacidad" }],
    },
  ];
}

/** Pie de las páginas públicas: marca, enlaces del sitio, ayuda y legal.
 * Sin teléfono ni correo públicos. */
export function SiteFooter({ page }: { page: SitePage }) {
  const year = Math.max(2026, new Date().getFullYear());
  return (
    <footer className={`t123-sitefooter${page === "organizer" ? " t123-sitefooter--with-bar" : ""}`} data-t123-footer="">
      <div className="t123-shell t123-sitefooter__grid">
        <div className="t123-sitefooter__brand">
          <Link to={siteHomePath()} aria-label="Torneos123, ir al inicio">
            <img
              src={publicAsset("torneos123/logo-torneos123-header-on-dark.png")}
              alt="Torneos123"
              width={900}
              height={187}
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p>La plataforma para organizar torneos de tenis, pádel y pickleball.</p>
        </div>

        {footerColumns(page).map((column) => (
          <nav key={column.id} className="t123-sitefooter__col" aria-labelledby={column.id}>
            <h2 id={column.id}>{column.title}</h2>
            <ul>
              {column.links.map((link) => (
                <li key={link.label}>
                  <SiteLink to={link.to}>{link.label}</SiteLink>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="t123-shell t123-sitefooter__bottom">
        <p>© {year} Torneos123</p>
      </div>
    </footer>
  );
}
